import React, { useState, forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with show/hide toggle.
 * Use exactly like <Input />; passes data-testid through.
 */
const PasswordInput = forwardRef(function PasswordInput(
    { className = '', testIdShow, ...props },
    ref
) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <Input
                ref={ref}
                type={show ? 'text' : 'password'}
                className={`pr-11 ${className}`}
                {...props}
            />
            <Button
                type="button"
                variant="ghost"
                size="icon"
                tabIndex={-1}
                onClick={() => setShow((s) => !s)}
                aria-label={show ? 'Hide password' : 'Show password'}
                aria-pressed={show}
                className="absolute right-1 top-1/2 -translate-y-1/2 h-9 w-9 text-[#1a3a5c]/70 hover:bg-[#1a3a5c]/5"
                data-testid={testIdShow}
            >
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </Button>
        </div>
    );
});

export default PasswordInput;
